<ul *ngIf="amazonItems">
    <li *ngFor="let item of amazonItems.items">
        
        <mat-card *ngFor="let summary of item.summaries" class="card-container">
            <mat-card-title>{{ summary.itemName }}</mat-card-title>
            <mat-card-subtitle>Source: Amazon</mat-card-subtitle>
       
        <mat-card-content class="info-container">
            <c-carousel [animate]="false" transition="crossfade" class="carousel-view">
                <c-carousel-indicators></c-carousel-indicators>
                <c-carousel-inner>
                    <c-carousel-item *ngFor="let image of item.images[0].images">
                        <img [src]="image.link" alt="some image" loading="lazy" class="d-block w-100">
                    </c-carousel-item>

                </c-carousel-inner>
                <c-carousel-control caption="Previous" direction="prev"></c-carousel-control>
                <c-carousel-control caption="Next" direction="next"></c-carousel-control>
            </c-carousel>
            <h3>Attributes</h3>
            <div>
                <p>Brand: {{ summary.brandName }}</p>
                <p>Color: {{ summary.colorName }}</p>
                <p>Manufacturer: {{ summary.manufacturer }}</p>
                <p>Model: {{ summary.modelNumber }}</p>
                <p>Size: {{ summary.sizeName }}</p>
                
            </div>
        </mat-card-content>
         </mat-card>
    
    </li>
</ul>